import { render, staticRenderFns } from "./MarketDynamics.vue?vue&type=template&id=b3b35efe&scoped=true"
import script from "./MarketDynamics.vue?vue&type=script&lang=js"
export * from "./MarketDynamics.vue?vue&type=script&lang=js"
import style0 from "./MarketDynamics.vue?vue&type=style&index=0&id=b3b35efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b35efe",
  null
  
)

export default component.exports